// Dependencies
import React, { useState, useEffect } from 'react';
import { NavLink } from "react-router";

// App components
import ButtonFull from '../buttons/ButtonFull';

// Helper functions
import { checkUserIsAdmin } from '../../global_components/helper_functions/checkUserIsAdmin';

const AppHeader = () => {
  const [userName, setUserName] = useState('');
  const [statusMessage, setStatusMessage] = useState("");
  const [isAdmin, setIsAdmin] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  useEffect(() => {
    checkUserIsAdmin(setIsAdmin, setStatusMessage);
  }, []);

  useEffect(() => {
    const fetchUserName = async () => {
      try {
        const response = await fetch("https://wad-backend.ws381566.remote.ac/getUserName.php", {
          method: "GET",
          credentials: "include",
          headers: { "Content-Type": "application/json" },
          mode: "cors",
        });
        
        const result = await response.json();
        if (result.status === "success") {
          setUserName(result.fullName);
        } else {
          setStatusMessage(result.message || "Failed to fetch username");
        }
      } catch (error) {
        setStatusMessage(error.message);
      }
    };

    fetchUserName();
  }, []);

  return (
    <div className='w-full flex items-center justify-between px-20 py-4 bg-white border-b border-gray-300 shadow-sm relative'>
        <div className='flex flex-col'>
            <h2 className='text-2xl font-bold text-black sm:text-lg xs:text-base md:text-xl lg:whitespace-nowrap sm:whitespace-normal'>
                Don't Get Mugged!
            </h2>
            <h4 className='text-md font-medium text-[#06BD60] uppercase mt-1'>Training Co.</h4>
        </div>
        <button className="lg:hidden p-2 text-black focus:outline-none" onClick={() => setIsMenuOpen(!isMenuOpen)}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" strokeWidth="2" viewBox="0 0 24 24" strokeLinecap="round" strokeLinejoin="round">
            <path d="M4 6h16M4 12h16M4 18h16" />
            </svg>
        </button>
        <div className={`absolute lg:static top-full left-0 w-full bg-white lg:bg-transparent shadow-md lg:shadow-none flex flex-col lg:flex-row items-center lg:justify-center gap-4 lg:gap-10 p-4 lg:p-0 transition-all duration-300 ${isMenuOpen ? 'block' : 'hidden'} lg:flex`}>
            <NavLink to='/dashboard/courses' className={({ isActive }) => isActive ? 'text-[#06BD60] font-medium' : 'text-black font-medium'}>Courses</NavLink>
            {isAdmin && <NavLink to='/dashboard/add-new-course' className={({ isActive }) => isActive ? 'text-[#06BD60] font-medium' : 'text-black font-medium'}>Add new course</NavLink>}
            <NavLink to='/dashboard/account' className={({ isActive }) => isActive ? 'text-[#06BD60] font-medium' : 'text-black font-medium'}>Account</NavLink>
            {isAdmin && <NavLink to='/dashboard/users' className={({ isActive }) => isActive ? 'text-[#06BD60] font-medium' : 'text-black font-medium'}>Users</NavLink>}
            <NavLink to='/dashboard/help' className={({ isActive }) => isActive ? 'text-[#06BD60] font-medium' : 'text-black font-medium'}>Support</NavLink>
            <NavLink to='/logout' className='text-black font-medium hover:text-[#06BD60] lg:hidden'>Logout</NavLink>
        </div>
        <div className='hidden lg:flex items-center gap-6'>
            <div className='flex items-center text-base font-medium whitespace-nowrap'>
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" className="feather feather-user mr-2">
                <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
                <circle cx="12" cy="7" r="4" />
            </svg>
            {userName}
            </div>
            <ButtonFull buttonText='Logout' navigationURL='/logout' />
        </div>
    </div>
  );
}

export default AppHeader;

